<template>
  <tender-header v-if="!isTemplate"></tender-header>
  <div :class="['tender-layout tender-layout-view', isTemplate ? 'print-area' : '']">
    <tender-notice></tender-notice>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import TenderHeader from './comps/header'
import TenderNotice from './comps/notice'
export default {
  name: 'BearTenderViewer',
  components: {
    TenderHeader,
    TenderNotice
  },
  computed: {
    ...mapState(['isTemplate'])
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.requestConfig().then(config => {
        this.setConfig(config)
      })
    },
    ...mapMutations([
      'setConfig'
    ]),
    ...mapActions([
      'requestConfig'
    ])
  }
}
</script>
<style lang="scss" scoped>
.tender-layout {
  padding: 5px;
  background: #f1f2f7;
}
.tender-layout {
  &.print-area {
    background: white;
  }
}
</style>